import Documents from "@/docs/Documents.vue";

export const docsRoutes = [
  {
    path: "/docs",
    component: Documents,
    props: {
      withSearchInput: false,
    },
    meta: {
      requiresAuth: true,
      requiresAdminProfile: true,
    },
    children: [
      {
        name: "Home-documentacao",
        path: "home",
        component: () => import("@/docs/pages/home/home.vue"),
      },
      {
        name: "dashboard-lojista",
        path: "dashboard-lojista",
        component: () => import("@/docs/pages/lojista/Dashboard/dashboard.vue"),
      },
      {
        name: "Consumidores-lojista",
        path: "consumidores",
        component: () =>
          import("@/docs/pages/lojista/Consumidores/Consumidores.vue"),
      },
      {
        name: "Usuarios-lojista",
        path: "usuarios",
        component: () => import("@/docs/pages/lojista/Usuarios/usuarios.vue"),
      },
      {
        name: "Vendas-lojista",
        path: "gerenciar",
        component: () => import("@/docs/pages/lojista/Vendas/gerenciar.vue"),
      },
      {
        name: "Cupons de Desconto-lojista",
        path: "vendas/cuponslojista",
        component: () =>
          import("@/docs/pages/lojista/Vendas/cuponslojista.vue"),
      },
      {
        name: "Pacotes de Ingressos-lojista",
        path: "vendas/pacoteslojista",
        component: () =>
          import("@/docs/pages/lojista/Vendas/pacoteslojista.vue"),
      },
      {
        name: "Relatorios-lojista",
        path: "relatorios",
        component: () =>
          import("@/docs/pages/lojista//Relatorios/relatorios.vue"),
      },
      {
        name: "Dados Cadastrais-lojista",
        path: "dados-da-loja/dados-cadastrais",
        component: () =>
          import("@/docs/pages/lojista/DadosDaLoja/DadosCadastrais.vue"),
      },
      {
        name: "ChangeLog",
        path: "updates",
        component: () => import("@/docs/pages/changelog/updates.vue"),
      },
      {
        name: "Gerenciar-docs-lojista",
        path: "produtos/gerenciar",
        component: () => import("@/docs/pages/lojista/Produtos/gerenciar.vue"),
      },
      {
        name: "Regras e Periodos-lojista",
        path: "produtos/regras-e-periodos",
        component: () =>
          import("@/docs/pages/lojista/Produtos/regrasPeriodos.vue"),
      },
      {
        name: "Ingressos-lojista",
        path: "produtos/ingressos",
        component: () => import("@/docs/pages/lojista/Produtos/ingressos.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO ADMIN ---- //
      // ---- Dashboard ---- //
      {
        name: "Login-admin",
        path: "dashboard/login",
        component: () => import("@/docs/pages/admin/Dashboard/login.vue"),
      },
      {
        name: "Dashboard-admin",
        path: "dashboard-admin",
        component: () => import("@/docs/pages/admin/Dashboard/dashboard.vue"),
      },
      // ---- Lojas ---- //
      {
        name: "Consumidor-admin",
        path: "lojas/consumidor",
        component: () => import("@/docs/pages/admin/Lojas/consumidor.vue"),
      },
      {
        name: "Gerenciar-admin",
        path: "lojas/gerenciar",
        component: () => import("@/docs/pages/admin/Lojas/gerenciar.vue"),
      },
      {
        name: "Segmento-admin",
        path: "lojas/segmento",
        component: () => import("@/docs/pages/admin/Lojas/segmento.vue"),
      },
      {
        name: "Usuarios-docs-admin",
        path: "lojas/usuarios",
        component: () => import("@/docs/pages/admin/Lojas/usuarios.vue"),
      },
      {
        name: "Regraspag-docs-admin",
        path: "lojas/regraspag",
        component: () => import("@/docs/pages/admin/Lojas/regraspag.vue"),
      },
      // ---- Marketplace ---- //
      {
        name: "marketplace-consumidor-admin",
        path: "marketplace/consumidor",
        component: () =>
          import("@/docs/pages/admin/Marketplace/consumidor.vue"),
      },
      // ---- Marketing ---- //
      {
        name: "Marketing-admin",
        path: "marketing",
        component: () =>
          import("@/docs/pages/admin/Marketing/configuracoes.vue"),
      },
      // ---- Operacoes ---- //
      {
        name: "Operacoes-admin",
        path: "operacoes/equipamentos",
        component: () =>
          import("@/docs/pages/admin/Operacoes/equipamentos.vue"),
      },
      // ---- Pessoas ---- //
      {
        name: "Pontos de Venda-admin",
        path: "pessoas/pontos-de-venda",
        component: () => import("@/docs/pages/admin/Pessoas/pontosDeVenda.vue"),
      },
      {
        name: "Tipos de Pontos de Venda-admin",
        path: "pessoas/tipos-pontos-de-vendas",
        component: () =>
          import("@/docs/pages/admin/Pessoas/tiposPontosVenda.vue"),
      },
      {
        name: "Usuarios-pessoas-admin",
        path: "pessoas/usuarios",
        component: () => import("@/docs/pages/admin/Pessoas/usuarios.vue"),
      },
      // ---- Produtos ---- //
      {
        name: "produtos-gerenciar-admin",
        path: "produtos/gerenciar-admin",
        component: () => import("@/docs/pages/admin/Produtos/gerenciar.vue"),
      },
      {
        name: "produtos-categorias-admin",
        path: "produtos/categorias-admin",
        component: () => import("@/docs/pages/admin/Produtos/categorias.vue"),
      },
      // ---- Relatorios ---- //
      {
        name: "Relatório Analitico-admin",
        path: "relatorios/analitico-admin",
        component: () => import("@/docs/pages/admin/Relatorios/analitico.vue"),
      },
      {
        name: "Relatório Sintetico-admin",
        path: "relatorios/sintetico-admin",
        component: () => import("@/docs/pages/admin/Relatorios/sintetico.vue"),
      },
      // ---- Termos ---- //
      {
        name: "Termos-admin",
        path: "termos",
        component: () => import("@/docs/pages/admin/Termos/termos.vue"),
      },
      // ---- Vendas ---- //
      {
        name: "Vendas-admin",
        path: "vendas-admin",
        component: () => import("@/docs/pages/admin/Vendas/gerenciar.vue"),
      },
      {
        name: "Cupons de Desconto-admin",
        path: "vendas/cupons",
        component: () => import("@/docs/pages/admin/Vendas/cupons.vue"),
      },
      {
        name: "Pacotes de Ingressos-admin",
        path: "vendas/pacotes",
        component: () => import("@/docs/pages/admin/Vendas/pacotes.vue"),
      },
      // ---- Financeiro ---- //
      {
        name: "Formas de Pagamento-admin",
        path: "financeiro/forma-de-pagamento",
        component: () =>
          import("@/docs/pages/admin/Financeiro/formasPagamento.vue"),
      },
      {
        name: "Regionais-admin",
        path: "financeiro/regionais",
        component: () => import("@/docs/pages/admin/Financeiro/regionais.vue"),
      },
      // ---- Configurações ---- //
      {
        name: "Omnichannel-admin",
        path: "configuracoes/ambientes",
        component: () =>
          import("@/docs/pages/admin/Configuracoes/ambientes.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO STORE ---- //
      {
        name: "pagina-inicial-store",
        path: "pagina-inicial-store",
        component: () => import("@/docs/pages/store/paginaInicial.vue"),
      },
      {
        name: "fluxo-compra-store",
        path: "fluxo-compra-store",
        component: () => import("@/docs/pages/store/fluxoCompra.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO VALIDATOR ---- //
      {
        name: "login-validator",
        path: "login-validator",
        component: () => import("@/docs/pages/validator/login.vue"),
      },
      {
        name: "processo-validator",
        path: "processo-validator",
        component: () => import("@/docs/pages/validator/processo.vue"),
      },
      {
        name: "outras-opt-validator",
        path: "outras-opt-validator",
        component: () => import("@/docs/pages/validator/outrasOpcoes.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO POS ---- //
      {
        name: "inicializacao-pos-first",
        path: "inicializacao-pos",
        component: () => import("@/docs/pages/pos/pos/inicializacao.vue"),
      },
      {
        name: "tela-inicial-pos-first",
        path: "tela-inicial-pos",
        component: () => import("@/docs/pages/pos/pos/telaInicial.vue"),
      },
      {
        name: "processoCompra-pos-first",
        path: "processo-compra-pos",
        component: () => import("@/docs/pages/pos/pos/processoCompra.vue"),
      },
      {
        name: "outrasOpt-pos-first",
        path: "outras-opt-pos",
        component: () => import("@/docs/pages/pos/pos/outrasOpt.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO POS ADMIN ---- //
      {
        name: "acesso-pos-adm",
        path: "acesso-pos-admin",
        component: () => import("@/docs/pages/pos/posAdmin/acesso.vue"),
      },
      {
        name: "dados-pos-adm",
        path: "dados-pos-admin",
        component: () => import("@/docs/pages/pos/posAdmin/dados.vue"),
      },
      {
        name: "geral-pos-adm",
        path: "geral-pos-admin",
        component: () => import("@/docs/pages/pos/posAdmin/geral.vue"),
      },
      // ---- ROTAS DOCUMENTAÇÃO POS QR ---- //
      {
        name: "dashboard-pos-qr",
        path: "dashboard-pos-qr",
        component: () => import("@/docs/pages/pos/posQR/posQR.vue"),
      },
      // ---- ROTA DE PESQUISA ---- //
      {
        name: "search",
        path: "search",
        component: () => import("@/docs/pages/search/search.vue"),
      },
    ],
  },
];
